import * as React from "react";

import {Checkbox, Flag, Icon, Label, Pagination, Segment, Tab, Table} from "semantic-ui-react";

import {ModeltypeBasicDto, OptionDto, OptionTextDto} from "../../../services/Client";
import {DerivateUtils} from "../../../components/Table/components/derivate/DerivateUtils";
import Button from "../../../components/Button";
import {sortTexts} from "../../../components/Table/dataHandler/Utils";
import DataAdapterOptionsView from "../DataAdapterOptionsView";
import PromtFormatter from "src/components/Table/components/reactQuill/PromtFormatter";

export enum SelectAction {
    SingleSelect = 0,
    SelectAll = 1,
    DeselectAll = 2
}

interface IUDASummaryStepProps {

    /** Selected derivates */
    derivates: ModeltypeBasicDto[];

    maintenanceStepItems: DataAdapterOptionsView[];
    startedWfItems: DataAdapterOptionsView[];
    invalidItems: DataAdapterOptionsView[];

    /** Options to be updated */
    updateItems: Map<OptionDto, boolean>;

    /** Translation */
    t: reactI18Next.TranslationFunction;

    /** Action for moving to previous step */
    onStepForward: () => void;

    /** Action for moving to next step */
    onStepBackwards: () => void;

    /** Action on table item select */
    handleSelectChange: (item: DataAdapterOptionsView[], resetFlag: boolean, actionType: number) => void;

    userLanguage: string;
}

interface IUDASummaryStepState {
    startedWfTab: number;
    maintenanceStepTab: number;
    invalidItemsTab: number;
}

export class UDASummaryStep extends React.Component<IUDASummaryStepProps, IUDASummaryStepState> {

    constructor(props: IUDASummaryStepProps) {
        super(props);

        this.state = {
            startedWfTab: 1,
            maintenanceStepTab: 1,
            invalidItemsTab: 1
        };
    }

    componentDidUpdate(prevProps: Readonly<IUDASummaryStepProps>): void {
        if (prevProps.derivates !== this.props.derivates) {
            this.setState({
                startedWfTab: 1,
                maintenanceStepTab: 1,
                invalidItemsTab: 1
            });
        }
    }

    getTableHeader = (checkbox?: boolean, itemsTotal?: DataAdapterOptionsView[], allSelected?: boolean, resetFlag?: boolean): JSX.Element => {
        return (
            <Table.Header>
                <Table.Row>
                    {checkbox && <Table.HeaderCell rowSpan={2}>
                        <Checkbox
                            slider={true}
                            checked={allSelected}
                            onChange={() =>
                                this.props.handleSelectChange(
                                    itemsTotal || [],
                                    resetFlag === true,
                                    allSelected ? SelectAction.DeselectAll : SelectAction.SelectAll
                                )}
                        />
                    </Table.HeaderCell>}
                    <Table.HeaderCell rowSpan={2}>{this.props.t("UPDATE_DRF_ASGN:OPTION_IDENTIFIER")}</Table.HeaderCell>
                    <Table.HeaderCell rowSpan={2}>{this.props.t("UPDATE_DRF_ASGN:SHORTTEXT")}</Table.HeaderCell>
                    <Table.HeaderCell colSpan={this.props.derivates.length}>{this.props.t("UPDATE_DRF_ASGN:DERIVATE_ASSIGNMENTS")}</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                    {this.props.derivates.map((der, index) =>
                        <Table.HeaderCell className='table-header-derivates-assignments' key={'der-' + index}>
                            {DerivateUtils.renderKeyDerivate(der, this.props.userLanguage)}
                        </Table.HeaderCell>
                    )}
                </Table.Row>
            </Table.Header>
        );
    }

    getTableBody = (items: DataAdapterOptionsView[], checkbox?: boolean, resetFlag?: boolean): JSX.Element => {
        return (
            <Table.Body>
                {items.map((item: DataAdapterOptionsView, index: number) => {
                    return (
                        <Table.Row key={'row-' + index}>
                            {checkbox && <Table.Cell>
                                <Checkbox
                                    slider={true}
                                    checked={this.props.updateItems.has(item.dto)}
                                    onChange={() => this.props.handleSelectChange([item], resetFlag === true, SelectAction.SingleSelect)}
                                />
                            </Table.Cell>}
                            <Table.Cell>
                                <Label size={'large'} className={'whitespace--nowrap'}>
                                    {item.optionBasicView}
                                    <Label.Detail>
                                        {item.optionTypeView}
                                    </Label.Detail>
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Segment.Group horizontal={true}>
                                    {item.texts.sort(sortTexts)
                                        .map((txt: OptionTextDto, idx: number) =>
                                            <Segment
                                                key={"txt-" + idx}
                                                className={'update-draft-asgn-text-segment'}
                                            >
                                                <Flag
                                                    name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                                                    className={'update-draft-asgn-text-flag'}

                                                />
                                                {txt.shorttext || ""}
                                            </Segment>
                                        )}
                                </Segment.Group>
                            </Table.Cell>
                            {this.props.derivates.map((mtb, idx) =>
                                <Table.Cell key={'der-' + idx}>{DerivateUtils.getAMTBIcon(item.dto.modeltypes || [], mtb)}</Table.Cell>
                            )}
                        </Table.Row>
                    );
                })}
            </Table.Body>
        );
    }

    getTableFooter = (colSpan: number, itemsTotal: number, invalidTab: boolean, resetFlag?: boolean): JSX.Element => {
        return (
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan={colSpan + this.props.derivates.length}>
                        <Pagination
                            activePage={invalidTab ? this.state.invalidItemsTab
                                : resetFlag ? this.state.startedWfTab : this.state.maintenanceStepTab}
                            totalPages={Math.ceil(itemsTotal / 10)}
                            onPageChange={(e, c) =>
                                invalidTab ? this.setState({invalidItemsTab: c.activePage as number})
                                    : resetFlag
                                        ? this.setState({startedWfTab: c.activePage as number})
                                        : this.setState({maintenanceStepTab: c.activePage as number})
                            }
                        />
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        );
    }

    getTabTable = (itemsTotal: DataAdapterOptionsView[], resetFlag: boolean): JSX.Element => {
        return (
            <Table
                celled={true}
                structured={true}
                textAlign={"center"}
            >
                {this.getTableHeader(
                    true,
                    itemsTotal,
                    itemsTotal.every((val) => this.props.updateItems.has(val.dto)),
                    resetFlag
                )}

                {this.getTableBody(
                    resetFlag
                        ? itemsTotal.slice((this.state.startedWfTab - 1) * 10, this.state.startedWfTab * 10)
                        : itemsTotal.slice((this.state.maintenanceStepTab - 1) * 10, this.state.maintenanceStepTab * 10),
                    true,
                    resetFlag
                )}

                {this.getTableFooter(
                    3,
                    itemsTotal.length,
                    false,
                    resetFlag
                )}
            </Table >
        );
    }

    getInvalidTab = (itemsTotal: DataAdapterOptionsView[]): JSX.Element => {
        return (
            <Table
                celled={true}
                structured={true}
                textAlign={"center"}
            >
                {this.getTableHeader()}
                {this.getTableBody(itemsTotal.slice((this.state.invalidItemsTab - 1) * 10, this.state.invalidItemsTab * 10))}
                {this.getTableFooter(2, itemsTotal.length, true)}
            </Table>
        );
    }

    getTabs = () => {
        const tabs = [];

        if (this.props.startedWfItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'wf-started-tab',
                    className: 'update-draft-asgn-wf-started-tab',
                    content: (
                        <b style={{color: 'orange'}}>{this.props.t("UPDATE_DRF_ASGN:WF_STARTED_TAB")}</b>
                    )
                },
                render: () => this.getTabTable(this.props.startedWfItems, true)
            });
        }

        if (this.props.maintenanceStepItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'maintenance-step-tab',
                    className: 'update-draft-asgn-maintenance-step-tab',
                    content: (
                        <b style={{color: 'green'}}>{this.props.t("UPDATE_DRF_ASGN:MAINTENANCE_WF_TAB")}</b>
                    )
                },
                render: () => this.getTabTable(this.props.maintenanceStepItems, false)
            });
        }

        if (this.props.invalidItems.length > 0) {
            tabs.push({
                menuItem: {
                    key: 'invalid-tab',
                    className: 'update-draft-asgn-invalid-tab',
                    content: (
                        <b style={{color: 'red'}}>{this.props.t("UPDATE_DRF_ASGN:INVALID_ITEMS_TAB")}</b>
                    )
                },
                render: () => this.getInvalidTab(this.props.invalidItems),
            });
        }

        return tabs;
    }

    render() {
        const {t} = this.props;
        const totalItemsCount = this.props.startedWfItems.length + this.props.maintenanceStepItems.length + this.props.invalidItems.length;

        return (
            <>
                <div style={{marginBottom: '20px'}}>
                    <p>
                        <b>{totalItemsCount} </b>{t("UPDATE_DRF_ASGN:ALL_ITEMS_COUNT")}
                    </p>

                    {this.props.startedWfItems.length > 0 &&
                        <p>
                            <b style={{color: 'orange'}}>{this.props.startedWfItems.length} </b>
                            {t("UPDATE_DRF_ASGN:WF_STARTED_COUNT") + ' ' + t("UPDATE_DRF_ASGN:WF_STARTED_COUNT_TXT", {tab: t("UPDATE_DRF_ASGN:WF_STARTED_TAB")})}
                        </p>
                    }

                    {this.props.maintenanceStepItems.length > 0 &&
                        <p>
                            <b style={{color: 'green'}}>{this.props.maintenanceStepItems.length} </b>
                            {t("UPDATE_DRF_ASGN:MAINTENANCE_WF_COUNT") + ' ' + t("UPDATE_DRF_ASGN:MAINTENANCE_WF_COUNT_TXT", {tab: t("UPDATE_DRF_ASGN:MAINTENANCE_WF_TAB")})}
                        </p>
                    }

                    {this.props.invalidItems.length > 0 &&
                        <div className={"display--flex"}>
                            <Icon name="warning sign" color="red" />
                            <p>
                                <b style={{color: 'red'}}>{this.props.invalidItems.length} </b>
                                {t("UPDATE_DRF_ASGN:INVALID_ITEMS_COUNT", {tab: t("UPDATE_DRF_ASGN:INVALID_ITEMS_TAB")})}
                            </p>
                        </div>
                    }
                </div>

                <Tab
                    panes={this.getTabs()}
                    menu={{pointing: true}}
                    className={'scrollbarX'}
                />

                <div style={{marginTop: '30px'}}>
                    <Button
                        icon={'arrow left'}
                        onClick={this.props.onStepBackwards}
                    />
                    {(this.props.maintenanceStepItems.length > 0 || this.props.startedWfItems.length > 0) &&
                        <div style={{float: 'right'}}>
                            {this.props.updateItems.size < 1 &&
                                <Label color={'red'} pointing={'right'}>
                                    <Icon name={'warning'} />
                                    {t("UPDATE_DRF_ASGN:EMPTY_LIST_HINT")}
                                </Label>}
                            <Button
                                icon={'arrow right'}
                                style={{float: 'right'}}
                                disabled={this.props.updateItems.size < 1}
                                onClick={this.props.onStepForward}
                            />
                        </div>
                    }
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/updateDraftAssignments/UDASummaryStep.tsx